module.exports = __webpack_public_path__ + "img/education7.93fefe58.png";